import { useEffect } from "react";
import { useLocation, useMatch } from "react-router-dom";
import { SITE_URL, LAST_MODIFIED } from "./site";
import { HOME_SEO, getArticleSeo } from "./config";
import { applySeo, applyNoindex } from "./head";
import { injectHomeSchema, injectArticleSchema, removeAllSchema } from "./schema";

/**
 * Centralized route-aware SEO manager. It updates document title, description,
 * keywords, canonical, Open Graph, Twitter Card and Schema.org JSON-LD based on
 * the active route so metadata never leaks between routes.
 */
export default function SeoManager() {
  const location = useLocation();
  const articleMatch = useMatch("/guide/:slug");
  const slug = articleMatch?.params.slug;

  useEffect(() => {
    if (slug) {
      const seo = getArticleSeo(slug);
      if (seo) {
        applySeo(seo, SITE_URL);
        injectArticleSchema({
          title: seo.title,
          description: seo.description,
          image: seo.image,
          slug,
          dateModified: LAST_MODIFIED,
        });
        return;
      }
    }

    if (location.pathname === "/") {
      applySeo(HOME_SEO, SITE_URL);
      injectHomeSchema(HOME_SEO.description);
      return;
    }

    applyNoindex();
    removeAllSchema();
  }, [slug, location.pathname]);

  return null;
}